import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { useShowAlert } from 'hooks';
import strings from 'strings';
import FPIcon from 'UI/components/atoms/FPIcon';
import { buildAcceptedFilesArray } from 'UI/components/molecules/FileDropzone/fileDropzone.utils';
import { defaultValidExtNames } from 'UI/constants/defaults';
import { SvgUploadButton } from 'UI/res';
import { formatBytes } from 'UI/utils';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {string[]} props.allowedExtensions
 * @param {number} props.maxFileSize
 * @param {Function} props.onDropFinished
 */
const Dropzone = ({ allowedExtensions = defaultValidExtNames, onDropFinished, maxFileSize }) => {
  const classes = useStyles();
  const { showAlert } = useShowAlert();

  const allowedFileTypes = buildAcceptedFilesArray(allowedExtensions);

  const handleDropRejected = fileRejections => {
    if (fileRejections.length === 0) return;

    const allowedExtensionsStrings = allowedExtensions.join(', ');

    showAlert({
      severity: 'error',
      title: strings.fileManager.extFile.title,
      body: strings.formatString(strings.fileManager.extFile.message, {
        allowedExtensions: allowedExtensionsStrings
      })
    });
  };

  const onDrop = useCallback(files => onDropFinished(files), [onDropFinished]);

  const { getRootProps, getInputProps, isDragAccept } = useDropzone({
    onDrop,
    accept: allowedFileTypes,
    onDropRejected: handleDropRejected
  });

  return (
    <div
      {...getRootProps({
        className: clsx(classes.baseStyle, isDragAccept && classes.acceptStyle)
      })}
    >
      <input {...getInputProps()} />
      <span className={classes.textIconContainer}>
        <FPIcon component={SvgUploadButton} />
        <span className={classes.iconText}>
          {strings.formatString(strings.fileManager.dropzone.enabled, {
            maxFileSize: formatBytes(maxFileSize)
          })}
        </span>
      </span>
    </div>
  );
};

export default Dropzone;
